import React from "react";
import {
  InputNumber,
  InputNumberValueChangeEvent,
} from "primereact/inputnumber";
import { IconPlusBlack, IconMinus } from "../../assets/icons/Icon";
import {
  NumberContainer,
  StyledInputNumber,
  IconButton,
} from "./CustomInput.styles";

interface CustomInputNumProps {
  value: number | null;
  setValue: (value: number | null) => void;
  onBlur?: () => void;
  placeholder?: string;
  invalid?: boolean;
}

const CustomInputNumberIncrement: React.FC<CustomInputNumProps> = ({
  value,
  setValue,
  onBlur,
  placeholder,
  invalid,
}) => {
  const handleChange = (e: InputNumberValueChangeEvent) => {
    setValue(e.value ?? null);
  };

  const increment = () => {
    setValue((value ?? 0) + 1);
  };

  const decrement = () => {
    setValue((value ?? 0) - 1);
  };

  return (
    <NumberContainer invalid={invalid}>
      <IconButton onClick={decrement} type="button">
        <IconMinus size={14} />
      </IconButton>
      <StyledInputNumber
        value={value}
        onValueChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder || "Количество"}
        showButtons={false}
      />
      <IconButton onClick={increment} type="button">
        <IconPlusBlack size={14} />
      </IconButton>
    </NumberContainer>
  );
};

export default CustomInputNumberIncrement;
